<template>
	<!--筛选状态栏-->
	<div class="filter-status">
		<div class="total">共<strong>{{ total }}</strong>条记录</div>
		<div class="filter-btn" v-if="showFilterButton" @click="showFilterPopup = true"><i class="iconfont icon-shaixuan"></i>筛选</div>
	</div>
	<!--筛选关键词-展示-->
	<div class="filter-keywords" v-if="showFilterParams.length > 0">
		<div
				class="keyword"
				v-for="(item, index) in showFilterParams"
				:key="index"
		>
      <span @click="deleteFilterParams(item.code)">
        <span class="van-ellipsis">{{item.name+':'+item.value }}</span>
        <i class="iconfont icon-filter-delete"/>
      </span>
		</div>
	</div>
  <!--筛选弹出层-选择-->
  <FilterPopup ref="filterPopup" v-model:show="showFilterPopup" :facet-list="facetList" @filterParams="getFilterParams"/>
</template>
<script setup>
import {toRefs} from "@vue/reactivity";
import FilterPopup from './FilterPopup.vue';
import {ref} from 'vue';
const props = defineProps({
	total: {
		type: Number,
		default: 0
	},
  showFilterButton: {
    type: Boolean,
    default: true
  },
	showFilterParams: {
		type: Array,
		default: () => []
	},
  facetList: {
    type: Array,
    default: () => []
  }
});
const emit = defineEmits(['showFilterPopup','deleteFilterParams','getFilterParams'])
const{total,showFilterParams,showFilterButton,facetList}=toRefs(props);
const showFilterPopup = ref(false);
const filterPopup = ref()
function deleteFilterParams(key){
	 emit('deleteFilterParams',key);
}
function getFilterParams(params,showParams){
  emit('getFilterParams',params,showParams);
}
// 重置检索的选择
function resetPop(){
  filterPopup.value?.reset();
}
defineExpose({
  resetPop
})
</script>
<style scoped lang="less">
@import "../../assets/css/filter-status.less";
@import "../../assets/css/filter-keywords.less";
</style>
